import * as React from "react";
const SvgLikeFill20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17.902 3.527a5.36 5.36 0 0 0-7.494.509L10 4.495l-.408-.46a5.36 5.36 0 1 0-7.61 7.527L10 18.852l8.019-7.29a5.36 5.36 0 0 0-.117-8.035Z",
      clipRule: "evenodd"
    })
  );
export default SvgLikeFill20Px;
